// extracted by mini-css-extract-plugin
module.exports = {"jusiaAlert":"jusia-alert_jusiaAlert__OJHFP"};